import type { VariantProps } from 'class-variance-authority';
import NextLink from 'next/link';
import type { ReactNode } from 'react';

import { linkVariants } from '@/components/atoms/link/link-variants';
import { DigiprocAtomAbstract } from '@/services/types/digiproc-atom-abstract';

type InternalLinkProps = DigiprocAtomAbstract<
  VariantProps<typeof linkVariants> & {
    children: ReactNode;
    href: string;
    ariaLabel?: string;
  }
>;

export const InternalLink = ({
  children,
  href,
  ariaLabel,
  variant,
}: InternalLinkProps) => {
  return (
    <NextLink
      href={href}
      className={linkVariants({ variant })}
      aria-label={ariaLabel}
    >
      {children}
    </NextLink>
  );
};
